import { CampaignInfluencers } from '@anytag/shared-organisms';
import { useEngagementDetailsContext } from '../engagement-details-context';
import { useDefaultInfluencerSearchProps } from './hooks';

export const EngagementCampaignInfluencersSearch = () => {
  const { engagementId } = useEngagementDetailsContext();
  const { isEngagementPage } = useDefaultInfluencerSearchProps();

  return <CampaignInfluencers campaignId={engagementId} isEngagementPage={isEngagementPage} />;
};
